export default __webpack_public_path__ + "static/media/logo.019a7d75.png";